export default "__VITE_ASSET__DkWffDSh__"